import axios from 'axios'

export default {
  // API:10
  async getPayment(contractId) {
    return await axios.get(`users/ninal_billing_info/${contractId}`)
  },

  // API:15
  async getCreditCard(contractId) {
    return await axios.get(`users/mypage_ninal_contracts/${contractId}/credit_card`)
  },
  // API:16
  async updateCreditCard(contractId, token) {
    return await axios.post(`users/mypage_ninal_contracts/${contractId}/credit_card`, token)
  },
  async getValidityCheck(contractId, token, holdername) {
    return await axios.get(`users/mypage_ninal_contracts/${contractId}/validity_check`, {
      params: {
        token,
        holdername,
      },
    })
  },
}
